<div class="swiper-container" #swiper>
  <div class="swiper-wrapper">
    <div *ngFor="let image of filteredImages" class="swiper-slide">
      <div
        class="slide-content"
        [style.height]="item?.height"
        [ngStyle.lt-md]="{ 'height': item?.heightMob }"
      >
        <img
          (click)="openlink(image.navigatedUrl)"
          [src]="bannerServerPath + image.img"
          alt="Slide Image"
          class="slide-img"
        />
      </div>
    </div>
  </div>
</div>
